import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let PitFilterValue = class PitFilterValue {
    get valueInt() {
        return this._valueInt;
    }
    set valueInt(value) {
        this._valueInt = value;
    }
    get valueDouble() {
        return this._valueDouble;
    }
    set valueDouble(value) {
        this._valueDouble = value;
    }
    get valueDate() {
        return this._valueDate;
    }
    set valueDate(value) {
        this._valueDate = value;
    }
    get valueBoolean() {
        return this._valueBoolean;
    }
    set valueBoolean(value) {
        this._valueBoolean = value;
    }
    get valueString() {
        return this._valueString;
    }
    set valueString(value) {
        this._valueString = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "valueInt", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterValue.prototype, "_valueInt", void 0);
tslib_1.__decorate([
    jsonMember({ name: "valueDouble", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterValue.prototype, "_valueDouble", void 0);
tslib_1.__decorate([
    jsonMember({ name: "valueDate", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterValue.prototype, "_valueDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "valueBoolean", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitFilterValue.prototype, "_valueBoolean", void 0);
tslib_1.__decorate([
    jsonMember({ name: "valueString", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterValue.prototype, "_valueString", void 0);
PitFilterValue = tslib_1.__decorate([
    jsonObject
], PitFilterValue);
export { PitFilterValue };
